import { useMutation } from 'react-query';
import { putFavoriteQuestion } from '../model';

const favoriteQuestion = async (payload) => {
  // eslint-disable-next-line no-useless-catch
  try {
    const response = await putFavoriteQuestion(payload);
    return { response, isFavorite: payload.favorite };
  } catch (err) {
    throw err;
  }
};

export default function useMutateFavoriteQuestion(options) {
  return useMutation(favoriteQuestion, options);
}
